export default class DelayedExecutionHelper {
  static delay(delayConditionCallback, actionCallback) {
    setTimeout(() => {
      if (delayConditionCallback()) {
        this.delay(delayConditionCallback, actionCallback);
      }
      else {
        actionCallback();
      }
    }, 0);
  }
}